import '../banners.less';
import './index.less';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import Fade from 'react-reveal/Fade';
import Slider from 'react-slick';

import NextArrow from '../../../images/banners/next-arrow.jpg';
import PrevArrow from '../../../images/banners/prev-arrow.jpg';
import Breakpoint from '../../../utils/breakpoint';
import USP10 from '../../../videos/movements/AnteriorCore-CoreHold.mp4';
import USP7 from '../../../videos/movements/HipPull-Deadlift.mp4';
import USP5 from '../../../videos/movements/HipPush-Squat.mp4';
import USP1 from '../../../videos/movements/HorizontalPull-Row.mp4';
import USP3 from '../../../videos/movements/HorizontalPush-PushUp.mp4';
import USP9 from '../../../videos/movements/LocomotionBP-Burpee.mp4';
import USP8 from '../../../videos/movements/LocomotionMC-MountainClimbers.mp4';
import USP11 from '../../../videos/movements/PosteriorCore-BirdDog.mp4';
import USP6 from '../../../videos/movements/SingleLeg-Lunge.mp4';
import USP4 from '../../../videos/movements/VerticalPull-SquatPull.mp4';
import USP2 from '../../../videos/movements/VerticalPush-MedballOverheadPress.mp4';
import Title from '../../BannerShared/Title';

const CarouselUSPs = () => {
  const sliderVideos = useRef([]);
  // eslint-disable-next-line
  const [slide, setSlide] = useState(0);
  const slider = useRef();

  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 2,
    infinite: false,
    variableWidth: true,

    focusOnSelect: true,
  };

  const handleVideoPlayPause = (videoIndex) => {
    // loop through 11 items
    for (let i = 0; i < 11; i += 1) {
      if (i === videoIndex) {
        sliderVideos.current[i].play();
      } else {
        sliderVideos.current[i].pause();
      }
    }
  };

  const getSlideContent = (index = slide) => {
    switch (index) {
      case 0:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} autoPlay loop playsInline src={USP1} />
            <div className="slide-content">
              <h3>The Row</h3>
              <p>Horizontal Pull (Level 1) · 23 variations</p>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP2} />
            <div className="slide-content">
              <h3>The Overhead Press</h3>
              <p>Vertical Push (Level 1) · 21 variations</p>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP3} />
            <div className="slide-content">
              <h3>The Push-Up</h3>
              <p>Horizontal Push (Level 2) · 17 variations</p>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP4} />
            <div className="slide-content">
              <h3>The Squat Pull</h3>
              <p>Vertical Pull (Level 1) · 15 variations</p>
            </div>
          </>
        );
      case 4:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP5} />
            <div className="slide-content">
              <h3>The Squat</h3>
              <p>Hip Push (Level 1) · 23 variations</p>
            </div>
          </>
        );
      case 5:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP6} />
            <div className="slide-content">
              <h3>The Lunge</h3>
              <p>Single Leg (Level 1) · 25 variations</p>
            </div>
          </>
        );
      case 6:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP7} />
            <div className="slide-content">
              <h3>The Deadlift</h3>
              <p>Hip Pull (Level 1) · 25 variations</p>
            </div>
          </>
        );
      case 7:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP8} />
            <div className="slide-content">
              <h3>The Mountain Climber</h3>
              <p>Locamotion MC (Level 1) · 7 variations</p>
            </div>
          </>
        );
      case 8:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP9} />
            <div className="slide-content">
              <h3>The Burpee</h3>
              <p>Locamotion BP (Level 1) · 8 variations</p>
            </div>
          </>
        );
      case 9:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP10} />
            <div className="slide-content">
              <h3>The Core Hold</h3>
              <p>Anterior Core (Level 1) · 17 variations</p>
            </div>
          </>
        );
      case 10:
        return (
          <>
            <video ref={(el) => (sliderVideos.current[index] = el)} loop playsInline src={USP11} />
            <div className="slide-content">
              <h3>The Bird-Dog</h3>
              <p>Posterior Core (Level 1) · 9 variations</p>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="banner banner-carousel-movements">
      <div className="container">
        <div className="ksp-wrapper">
          <div className="ksp-bg">the movements</div>
        </div>
        <Row align="middle">
          <Col xs={24} sm={24} md={22} lg={22} xl={12}>
            <Fade
              onReveal={() => {
                // sliderVideos?.current[0]?.play();
              }}
            >
              <section>
                <Title title="The Movements" isTagline />
                <Title title="安全 & 有效" />
                <p>
                  RITUAL
                  HIIT对11种基础动作进行编排，在每节课设立4个等级的难度，去适配不同运动体能的学员，我们将围绕全面均衡发展、恢复力和健康等问题提供365天不同样的课程内容，让每天的训练在运动与休息的比例、运动的顺序和所需的总体强度方面灵活变化。这意味着训练者的身体也将不断变化，不断进步。
                </p>
                <Row>
                  <Col span={8}>
                    <div
                      className="workout-movement-usp"
                      style={{
                        paddingLeft: '0px',
                      }}
                    >
                      <div className="workout-movement-usp-title">11</div>
                      Movement Patterns
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      className="workout-movement-usp"
                      style={{
                        borderLeft: '1px solid #2E2E2E',
                        borderRight: '1px solid #2E2E2E',
                      }}
                    >
                      <div className="workout-movement-usp-title">4</div>
                      Difficulty Levels
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      className="workout-movement-usp"
                      style={{
                        paddingRight: '0px',
                      }}
                    >
                      <div className="workout-movement-usp-title">200+</div>
                      Individual Exercises
                    </div>
                  </Col>
                </Row>
              </section>
            </Fade>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={12}>
            <div className="carousel">
              <Slider
                onInit={() => {}}
                beforeChange={(current, next) => {
                  setSlide(next);
                  handleVideoPlayPause(next);
                }}
                ref={slider}
                {...settings}
              >
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(0)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(1)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(2)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(3)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(4)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(5)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(6)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(7)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(8)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(9)}</div>
                </div>
                <div className="slide">
                  <div className="slide-inner">{getSlideContent(10)}</div>
                </div>

                <div className="slide" />
              </Slider>
            </div>

            <Breakpoint min="sm">
              <>
                <div className="banner-arrow-container">
                  <div
                    className="banner-arrow"
                    onClick={() => {
                      slider.current.slickPrev();
                    }}
                  >
                    <img src={PrevArrow} alt="Prev" />
                  </div>
                  <div
                    className="banner-arrow"
                    onClick={() => {
                      if (slide < 10) {
                        slider.current.slickNext();
                      }
                    }}
                  >
                    <img src={NextArrow} alt="Next" />
                  </div>
                </div>
              </>
            </Breakpoint>
          </Col>
        </Row>
      </div>
    </div>
  );
};

CarouselUSPs.propTypes = {
  t: PropTypes.func,
};

export default CarouselUSPs;
